module.exports = __webpack_public_path__ + "static/media/wechat.f9f76ea.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/wechat.mp4
// module id = AE7E
// module chunks = 0